import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import promoService from '../../Services/promoService'
import Loader from '../../Components/Loader'
import { ChangeStatus } from '../../Components'
export const ReferralList = () => {
    const [originCourierChargeList, setOriginCourierChargeList] = useState([])
    const [pagination, setPagination] = useState({ page: 1, limit: 10 })
    const [currentPage, setCurrentPage] = useState(1)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loader, setLoader] = useState(true)
    const history = useHistory()

    useEffect(() => {
        getOriginCourierChargeList()
        // eslint-disable-next-line
    }, [currentPage])

    const getOriginCourierChargeList = () => {
        let param = { ...pagination, page: currentPage }
        promoService.getPromo(param).then(res => {
            if (res.status) {
                setLoader(false)
                setOriginCourierChargeList(res.data)
                setPagination(res.pagination)
            } else {
                setLoader(false)
            }
        })
    }

    const onModalSubmit = () => {
        let postData = {
            promo_id: isModalOpen._id,
        }
        promoService.deletePromo(postData).then(res => {
            if (res.status) {
                setIsModalOpen(false)
                getOriginCourierChargeList()
            }
        })
    }

    const onPageChangeEvent = (e) => {
        setLoader(true)
        setCurrentPage(e.selected + 1)
    }

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                            <button className="btn btn-primary w-sm waves-effect waves-light"
                            >Add Referral
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Code</th>
                                        <th>Amount / Percentage</th>
                                        <th>Type</th>
                                        <th>Start date - End date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {originCourierChargeList.length > 0 && originCourierChargeList.map((item, key) => (
                                        <tr key={key}>
                                            <td className="text-body fw-bold">{((pagination.page - 1) * pagination.limit) + (key + 1)}</td>
                                            <td>{item.promo_code}</td>
                                            <td>{item.promo_amount}</td>
                                            <td>
                                                <span className={"badge rounded-pill font-size-12" + (item.promo_type === 'PERCENTEGE' ? ' bg-success' : ' bg-soft-warning')}>
                                                    {item.promo_type}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="thumb-sm member-thumb m-b-10 center-block">
                                                    {moment(new Date(item.promo_start_date)).format('DD/MM/YYYY')}
                                                    &nbsp; -  &nbsp;
                                                    {moment(new Date(item.promo_end_date)).format('DD/MM/YYYY')}
                                                </div>
                                            </td>
                                            <td>
                                                <span
                                                    className={"badge rounded-pill font-size-12" + (item.local_origin_charge_status === 'ACTIVE' ? ' bg-success' : ' bg-soft-danger')}
                                                // onClick={() => setIsModalOpen(item)}
                                                >{item.promo_status}</span>
                                            </td>
                                            <td>
                                                {/* Button trigger modal */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm btn-rounded waves-effect waves-light m-1"
                                                    onClick={() => history.push('/edit-promo?id=' + item._id, item)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm btn-rounded waves-effect waves-light m-1"
                                                    onClick={() => setIsModalOpen(item)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {originCourierChargeList.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            }
                        </div>
                    </div>
                    {originCourierChargeList.length > 0 && pagination.totalRecord > pagination.limit &&
                        <ReactPaginate
                            previousLabel={<img src="assets/images/prev.svg" height={15} alt='prev' />}
                            forcePage={currentPage - 1}
                            nextLabel={<img src="assets/images/next.svg" height={15} alt='next' />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={(e) => onPageChangeEvent(e)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    }
                    <Loader isShow={loader} />
                </div>
                {Boolean(isModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(isModalOpen)}
                        title='Delete Promo'
                        message={`Are you sure want to delete promo code?`}
                        onSubmitEvent={() => onModalSubmit()}
                        handleClose={() => setIsModalOpen(false)}
                    />
                }
            </div>
        </div>
    )
}